import { render } from "./examination.vue?vue&type=template&id=067668a8&scoped=true"
import script from "./examination.vue?vue&type=script&lang=js"
export * from "./examination.vue?vue&type=script&lang=js"

import "./examination.vue?vue&type=style&index=0&id=067668a8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-067668a8"

export default script